import { c as _c } from "react/compiler-runtime";
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import useSWR from 'swr';
import { ContactId } from '../../types/contact-interface';
import { ContactAutomationTaskApiInterface } from '../types/contact-automation-task-interface';
import { ContactPageFilterInterface } from '../types/contact-page-filter-interface';
interface UseContactAutomationTasksInterface extends SwrPaginationInterface {
  contactId: ContactId;
  filter: ContactPageFilterInterface;
}
export function useContactAutomationTasks(t0) {
  const $ = _c(9);
  const {
    limit,
    pagination,
    contactId,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ""}${filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ""}`;
  let t2;
  if ($[1] !== contactId || $[2] !== filterApi || $[3] !== limit || $[4] !== pagination || $[5] !== user) {
    t2 = () => {
      if (user) {
        return `${CONTACT_API}/${contactId}/automation-rules/list?${getPaginationQueryString({
          limit,
          pagination
        })}${filterApi}`;
      }
      return null;
    };
    $[1] = contactId;
    $[2] = filterApi;
    $[3] = limit;
    $[4] = pagination;
    $[5] = user;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data: contactAutomationTasks
  } = useSWR(t2, fetcher);
  let t3;
  if ($[7] !== contactAutomationTasks) {
    t3 = {
      contactAutomationTasks
    };
    $[7] = contactAutomationTasks;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}